module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/search-eba1370f8535c5e37ad0bb8c1f082646.svg";